import React, { useContext, useEffect, useRef, useState } from 'react'
import { useTheme } from '@emotion/react'
import AppContext from 'context/app'
import Link from 'components/link'

export default function Violator({ style }){
    const theme = useTheme()
    const { clientWidth } = useContext(AppContext)
    const [top, setTop] = useState(null)

    useEffect(() => {
        if(typeof document === 'undefined') return
        const nav = document.querySelector('nav')
        setTop(nav?.clientHeight)
    }, [clientWidth])

    return(
        <Link
            id='violator'
            to='/press/inmusic-native/'
            className='d-block p-sticky text-center'
            style={{
                top,
                padding: 8,
                color: 'black',
                transitionProperty: 'background',
                ...style,
            }}
            css={{
                background: '#CECECE',
                '&:hover': { background: theme.colors.primary },
                [theme.queries.sm]: { fontSize: 14 },
            }}
        >
            <strong>Latest News:</strong>  inMusic and Native Instruments Unite
        </Link>
    )
}